import { observable } from "mobx";
import { SkillSmartProduct, HelpRequestPriority, EmptyId } from "./enums";
import { copy } from "../utils/data";


export class HelpRequest {
  @observable domain: string = "";
  @observable view: string = "";
  @observable subview: string = "";
  @observable app: SkillSmartProduct;
  @observable message: string = "";
  @observable email: string = "";
  @observable priority: HelpRequestPriority;
  @observable contractor: string = EmptyId;
  constructor(app: SkillSmartProduct.Seeker, priority: HelpRequestPriority = HelpRequestPriority.Medium) {
    const viewStr: string[] = window.location.hash.replace("#", "").split("?");
    this.view = viewStr[0];
    this.domain = window.location.host;
    this.priority = priority;
    this.app = app;
    this.contractor = "";
  }
}
///Class used to define the scope of the help topics requestsd
export class HelpTopicRequest {
  @observable domain: string = "";
  @observable view: string = "";
  @observable subview: string = "";
  @observable app: SkillSmartProduct;
  @observable mask: number = 0;
  @observable language: string = "en";

  constructor(app: SkillSmartProduct.Seeker) {
    this.view = window.location.hash.replace("#", "");
    this.domain = window.location.host;
    this.app = app;
  }
}

/// Holds definitions of the topics retrieved
export class HelpTopic {
  @observable title: string = "";
  @observable content: string = "";
  @observable category: number = 0;
  @observable parentCategory: number = 0;
  @observable topic: number = 0;

  constructor(ht?: HelpTopic) {
    if (ht) {
      copy(ht, this);
    }
  }
}

export class ExistingHelp {
  @observable view: string = "";
  @observable topics: Array<HelpTopic>;

  constructor() {
    this.topics = new Array<HelpTopic>();
  }
}



// WEBPACK FOOTER //
// ./src/models/integratedHelp.ts